export default "__VITE_ASSET__Dv2YeELc__"